export const UPDATE_COMPETITOR_PROFILE_REQUEST =
  "UPDATE_COMPETITOR_PROFILE_REQUEST";
export const UPDATE_COMPETITOR_PROFILE_SUCCESS =
  "UPDATE_COMPETITOR_PROFILE_SUCCESS";
export const UPDATE_COMPETITOR_PROFILE_FAILURE =
  "UPDATE_COMPETITOR_PROFILE_FAILURE";

export const updateCompetitorProfileRequest = (payload) => ({
  type: UPDATE_COMPETITOR_PROFILE_REQUEST,
  payload,
});

export const updateCompetitorProfileSuccess = () => ({
  type: UPDATE_COMPETITOR_PROFILE_SUCCESS,
});

export const updateCompetitorProfileFailure = (error) => ({
  type: UPDATE_COMPETITOR_PROFILE_FAILURE,
  payload: error,
});
